import axios from "axios";
import { getCookie, signout } from "../../helpers/auth";
import { toastCreater } from "../../helpers/utils";
// Yukleme oncesi video kucultme (telefonda, istemcide).
// mp4box/mp4-muxer bu modulun ICINDE dinamik yukleniyor, ana pakete girmiyor.
// Bkz. .agent/MEDYA-YUKLEME-KUCULTME.md
import { videoKucult } from "../../helpers/videoKucult";
// Parcali yukleme: sunucu onundeki (bizim kontrolumuzde olmayan) govde
// sinirini asmak ve kopan baglantida bastan baslamamak icin.
import { parcaliGonder, parcalanmaliMi } from "../../helpers/parcaliGonder";
import { yetkisizYonlendir, rolGecisiSuruyorMu } from "../../helpers/yetkiYonlendirme";

export function buttonApiRooter(buttonSettings, veri) {
  // govdesiz:true → gövde BOŞ ({}) gider. BE'nin gövdeyi kullanmadığı, yalnızca URL
  // param'ı (linkDegiskeni) ile çalışan aksiyon butonları için (ör. /api/mali/isleme).
  // Dolu gövde (URL/uzun metin içeren satır objesi) ters proxy/WAF tarafından 403
  // ("Forbidden" HTML) ile reddedilebiliyor. URL id yine veri'den alınır. (bkz .agent/GOTCHAS.md)
  const govde = buttonSettings.govdesiz ? {} : veri;
  switch (buttonSettings.action) {
    case "get":
      let data = [];
      getApi(buttonSettings.link).then((res) => {
        data = res;
        // console.log(res);
      });
      //   console.log(data);
      return data;

    case "post":
      if (buttonSettings.linkDegiskeni) {
        // console.log(buttonSettings);
        return postApi(
          buttonSettings.link + veri[buttonSettings.linkDegiskeni],
          govde
        );
      } else {
        return postApi(buttonSettings.link, govde, buttonSettings.returnToast);
      }

    case "put":
      if (buttonSettings.linkDegiskeni) {
        // console.log( buttonSettings.link + veri[buttonSettings.linkDegiskeni],veri);
        return putApi(
          buttonSettings.link + veri[buttonSettings.linkDegiskeni],
          govde
        );
      } else {
        return putApi(buttonSettings.link, govde);
      }

    case "delete":
      if (buttonSettings.linkDegiskeni) {
        return postApi(
          buttonSettings.link + veri[buttonSettings.linkDegiskeni],
          govde
        );
      } else {
        return postApi(buttonSettings.link, govde);
        // console.log(buttonSettings);
      }

    case "ilerlet":
      return ilerletApi(
        buttonSettings.link + veri[buttonSettings.linkDegiskeni]
      );

    default:
      return;
  }
}
const apiClient = axios.create({
  timeout: 60000, // 60 saniye
});

// Tüm apiClient çağrılarının ortak hata sınıflandırması (eskiden 6 yerde
// tekrarlanıyordu, bkz .agent/GOTCHAS.md). Durumlar:
// - 401: oturum/token geçersiz -> kullanıcıya söyle + signout()
// - 403: oturum GEÇERLİ ama bu işe yetki yok -> yalnızca uyarı, OTURUM KORUNUR
// - 413: istek/gövde çok büyük (dosya boyutu, gateway limiti) -> ayrı, net mesaj
// - err.response yok: istek BE'ye hiç ulaşmamış olabilir (CORS engeli, ters proxy/
//   WAF reddi, bağlantı kopması) -> bunu "bilinmeyen hata" değil, ayırt edilebilir söyle
//
// ⚠️ 401/403 AYRIMI BE İLE BİRLİKTE ÇALIŞIR (bkz. Backend V3 controllers/auth.js
// verify_token + .agent/HANDOFF.md §6b). Eskiden BE token sorunlarına da 403 dönüyor ve
// burada her 403 çıkışa yol açıyordu: yetkisi olmayan TEK bir endpoint kullanıcıyı
// çalışan oturumundan atıyordu (bildirimden gelen derin linkler bunu sürekli tetikledi).
// BE'nin 401 dönen sürümü olmadan bu dosya deploy edilmemeli — yoksa süresi dolmuş
// oturum hiç kapanmaz.
//
// 403'te ASLA rol değiştirme denenmez (HANDOFF §6b R1): 403 -> rol değiştir -> 403 ...
// kullanıcının sahip olduğu her rolde dönen bir döngü olur. Rol geçişi yalnızca
// BİLDİRİMİN kendi beyan ettiği rol için yapılır (bkz. helpers/bildirimRol.js).
function handleApiError(err) {
  if (err?.response) {
    const { status, data } = err.response;
    if (status === 401) {
      toastCreater("Giriş süreniz dolmuştur, tekrar giriş yapınız.", "e");
      signout();
    } else if (status === 403) {
      // Rol geçişi SÜRÜYORSA sus: sayfa eski rolle veri istemiş olabilir, geçiş bitince
      // zaten yeniden yüklenecek. Burada uyarı göstermek veya yönlendirmek, kullanıcının
      // tıkladığı bildirimin hedefinden atılması demek olurdu.
      if (rolGecisiSuruyorMu()) return;
      // Sayfa açılışındaki 403 ise kullanıcıyı görebileceği bir sayfaya taşı; buton
      // 403'ünde sayfada bırak (ayrımın gerekçesi: helpers/yetkiYonlendirme.js).
      const tasindi = yetkisizYonlendir();
      toastCreater(
        tasindi
          ? "Bu sayfa için yetkiniz yok, ana sayfanıza yönlendiriliyorsunuz."
          : (typeof data === "string" && data) || "Bu işlem için yetkiniz yok.",
        "e"
      );
    } else if (status === 413) {
      toastCreater("İstek çok büyük (veri/dosya boyutu limiti aşıldı).", "e");
    } else {
      toastCreater((data && data.detay) || data || "Hata", "e");
    }
  } else if (err?.code === "ECONNABORTED") {
    toastCreater("İstek 60 saniyede tamamlanamadı.", "e");
  } else {
    // response yok: sunucuya hiç ulaşmamış olabilir (CORS/ters proxy engeli, bağlantı kopması)
    toastCreater("Sunucuya ulaşılamadı (ağ veya erişim engeli olabilir).", "e");
  }
}
export function apiRooter(action, link, veri) {
  switch (action) {
    case "get":
      return getApi(link);

    case "post":
      return postApi(link, veri);

    case "put":
      return postApi(link, veri);
    case "delete":
      return postApi(link, veri);

    default:
  }
}

function getApi(link) {
  // console.log("get api " + link);
  return apiClient
    .get(link, {
      headers: {
        responseType: "blob",
        authorization: `Bearer ` + getCookie("token"),
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      handleApiError(err);
    });
}

async function postApi(link, veri) {
  let containsFile = false;
  if (veri) {
    // Hem üstte hem dizilerde/file alanlarında kontrol
    containsFile =
      Object.values(veri).some(v => v instanceof File || v instanceof Blob) ||
      Object.values(veri).some(v => Array.isArray(v) && v.some(it => it instanceof File || it instanceof Blob));
  }
 
 
 
  if (containsFile) {
    const formData = new FormData();
 
    for (const key of Object.keys(veri)) {
      const val = veri[key];
 
      // 1) Tekil File/Blob
      if (val instanceof File || val instanceof Blob) {
        formData.append(key, val, val.name || "upload.bin");
        continue;
      }
 
      // 2) Dizi
      if (Array.isArray(val)) {
        // Eğer dizi dosya dizisi ise ilkini gönder (backend maxCount=1)
        const firstFile = val.find(it => it instanceof File || it instanceof Blob);
        if (firstFile) {
          formData.append(key, firstFile, firstFile.name || "upload.bin");
          continue;
        }
        // Dosya değilse her elemanı ayrı ekle (key[]=... şeklinde istersen key yapısını değiştirebilirsin)
        val.forEach(item => formData.append(`${key}[]`, String(item)));
        continue;
      }
 
      // 3) Diğer nesneler (saf object) → metin alanı olarak gönder
      if (val && typeof val === "object") {
        formData.append(key, JSON.stringify(val));
        continue;
      }
 
      // 4) Primitive
      formData.append(key, val != null ? String(val) : "");
    }
 
    return await apiClient
      .post(link, formData, {
        headers: {
          Authorization: "Bearer " + getCookie("token"),
          // Content-Type'i elle yazma — axios FormData'dan otomatik belirler
        },
      })
      .then(res => res.data)
      .catch(err => {
        handleApiError(err);
      });
  } else {
    // Dosya yoksa JSON olarak gönder
    try {
      const res = await apiClient.post(link, veri, {
        headers: { Authorization: "Bearer " + getCookie("token") },
      });
      return res.data;
    } catch (err) {
      handleApiError(err);
    }
  }
}

// Bayt -> okunabilir MB. Kullaniciya "45.2 MB -> 6.1 MB" diyebilmek icin.
const mb = (bayt) => `${(bayt / 1048576).toFixed(1)} MB`;

export async function dosyaYuklemeApi(link, veri, setProgress) {
  let data = new FormData();

  // Kucultme yapildiysa ilerleme cubugu IKIYE bolunur: 0-50 hazirlama,
  // 50-100 yukleme. Boylece cubuk hep ileri gider; iki kez 0'dan baslayip
  // personeli "bastan mi basladi?" diye dusundurmez.
  // Kucultme yapilmadiysa (resim, excel, pdf, eski cihaz) eski davranis aynen
  // korunur: yukleme 0-100.
  let yuklemeTabani = 0;

  if (veri.data_file) {
    data.append("data_file", veri.data_file[0]);
  } else if (veri.media) {
    // KUCULTME BURADA (23-24.09.2026). Yukleme baslamadan once, telefonda.
    // videoKucult ASLA throw etmez; video degilse, cihaz desteklemiyorsa veya
    // is patlarsa orijinal dosyayi doner. Yani bu satir yuklemeyi engellemez.
    const sonuc = await videoKucult(veri.media[0], {
      ilerleme: (yuzde) => setProgress && setProgress(Math.round(yuzde / 2)),
    });
    if (sonuc.kucultuldu) {
      yuklemeTabani = 50;
      toastCreater(`Video kucultuldu: ${mb(veri.media[0].size)} -> ${mb(sonuc.dosya.size)}`, "s");
    } else if (sonuc.sebep && sonuc.sebep !== "video degil" && sonuc.sebep !== "zaten kucuk") {
      // Sahada neyin neden olmadigini anlayabilmek icin. Personele
      // gosterilmiyor: kucultulememesi onun icin bir sorun degil, yukleme surüyor.
      console.warn(`[yukleme] kucultme yapilamadi (${sonuc.sebep}), orijinal yukleniyor`);
    }

    // PARCALI YOL. Esigin ustundeki dosya tek istekte gonderilmiyor.
    // Yalnizca `media` dalinda: mutabakat (data_file/pdf) yollari mevcut ve
    // denenmis hallerinde birakildi.
    if (parcalanmaliMi(sonuc.dosya)) {
      const basliklar = {
        Authorization: "Bearer " + getCookie("token"),
        cpd_id: veri["_id"],
        proje_id: veri["proje_id"],
      };
      const kalan = 100 - yuklemeTabani;
      try {
        const cikti = await parcaliGonder(sonuc.dosya, {
          basla: (bilgi) =>
            apiClient.post("/api/media/parcali/basla", bilgi, { headers: basliklar }).then((r) => r.data),
          parcaGonder: (id, sira, blob) => {
            const fd = new FormData();
            fd.append("parca", blob, `${sira}.part`);
            return apiClient.post(`/api/media/parcali/${id}/${sira}`, fd, { headers: basliklar });
          },
          bitir: (id) =>
            apiClient.post(`/api/media/parcali/${id}/bitir`, {}, { headers: basliklar }).then((r) => r.data),
          ilerleme: (yuzde) =>
            setProgress && setProgress(yuklemeTabani + Math.round((yuzde * kalan) / 100)),
        });
        toastCreater("Yükleme işlemi tamamlandı.", "s");
        return cikti;
      } catch (err) {
        handleApiError(err);
        return undefined;
      }
    }

    data.append("media", sonuc.dosya);
  } else if (veri.pdf) {
    data.append("pdf", veri.pdf[0]);
  }

  return await apiClient
    .post(link, data, {
      onUploadProgress: (ProgressEvent) => {
        const ham = Math.round((ProgressEvent.loaded / ProgressEvent.total) * 100);
        setProgress(yuklemeTabani + Math.round((ham * (100 - yuklemeTabani)) / 100));
      },
      headers: {
        Authorization: "Bearer " + getCookie("token"),
        cpd_id: veri["_id"],
        proje_id: veri["proje_id"],
      },
    })
    .then((res) => {
      toastCreater("Yükleme işlemi tamamlandı.", "s");
      return res.data;
    })
    .catch((err) => {
      handleApiError(err);
    });
}

async function putApi(link, veri) {
  // console.log("put api " + link);
  // console.log( veri);
  return await apiClient
    .put(link, veri, {
      headers: {
        Authorization: "Bearer " + getCookie("token"),
      },
    })
    .then((res) => {
      //console.log(res);
      return res.data;
    })
    .catch((err) => {
      handleApiError(err);
    });
}

export async function deleteApi(link, veri) {
  // console.log("delete api " + link, veri);
  return await apiClient
    .delete(link, {
      headers: {
        Authorization: "Bearer " + getCookie("token"),
      },
    })
    .then((res) => {
      if (res.status === 200) {
        toastCreater("işlem gerçekleşti", "s");
      }
      return res.data;
    })
    .catch((err) => {
      handleApiError(err);
    });
}

export function ilerletApi(link) {
  // console.log("ilerlet  " + link);
  return axios
    .post(link, "", {
      headers: {
        Authorization: "Bearer " + getCookie("token"),
      },
    })
    .then((res) => {
      //   console.log(res.data);
      return res.data;
    })
    .catch((err) => {
      handleApiError(err);
    });
}
